export default {
  DRAFT: 'DRAFT',
  SUBMITTED_TO_DOCTOR: 'SUBMITTED_TO_DOCTOR',
  DOCTOR_APPROVED: 'DOCTOR_APPROVED',
  DOCTOR_REVISION_REQUESTED: 'DOCTOR_REVISION_REQUESTED',
} as const
